module.exports = __webpack_public_path__ + "public/images/shield.7cfd53248ccb9601c072029a2d924592.png";